<template>
  <AdminShell>
    <div class="head">
      <h2>Users</h2>
      <router-link to="/admin/users/new" class="btn">Create User</router-link>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Username</th>
          <th>Role</th>
          <th>Tenant</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in users" :key="u.id">
          <td>{{ u.username }}</td>
          <td>{{ u.role }}</td>
          <td>{{ u.tenant_name || "-" }}</td>
          <td>{{ u.is_active ? "Yes" : "No" }}</td>
        </tr>
      </tbody>
    </table>
  </AdminShell>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AdminShell from "@/components/admin/AdminShell.vue";
import { getUsers } from "@/services/admin";

const users = ref([]);

onMounted(async () => {
  const res = await getUsers();
  users.value = res.data?.users || [];
});
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.btn {
  background: #8b5cf6;
  color: #fff;
  text-decoration: none;
  padding: 10px 14px;
  border-radius: 10px;
}
.table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}
th, td {
  padding: 12px;
  border-bottom: 1px solid #eee;
}
</style>
